import {tns} from '../../../../node_modules/tiny-slider/src/tiny-slider';
import SliderPhotoContent from '../../utils/SliderPhotoContent';
import DraggableArea from '../../utils/DraggableArea';

'use strict'

class AboutUs{
    constructor(){
        
        this._sliderOficinas = new SliderPhotoContent(document.getElementById('slider_offices'));

        this._draggableAreaRecognitions = new DraggableArea(document.getElementById('recognitions_draggable_area'));

        this._draggableAreaCards = new DraggableArea(document.getElementById('cards_draggable_area'));

        // Slider recognitions
        this._sliderRecognitions = tns({
            container: '#slider_recognitions',
            nav: false,
            controls: false,
            mouseDrag: true,
            speed: 600,
            autoplayButtonOutput: false,
            slideBy: 1,
            center: true,
            preventScrollOnTouch: 'auto',
            preventActionWhenRunning: true,
            items: 1,
            loop: true,
            edgePadding: 25,
            onInit: (e) => {
                let pager = document.querySelector('.section_recognitions .slider-pager');
                pager.children[1].innerHTML = ("00" + e.slideCount).slice(-2);    
                
                if (window.innerWidth < 992) {
                    document.querySelectorAll('#slider_recognitions .tns-slide-active')[1].classList.add('slider-carousel__item--current');
                }
            },
            responsive: {
                420: {
                    edgePadding: 50,
                },
                540: {
                    edgePadding: 0,
                    items: 2,
                },
                768: {
                    items: 3,
                },
                992: {
                    disable: true,
                },
                1440: {
                    items: 4,
                },
            }
        }); 

         // Slider cards
         this._sliderCards = tns({
            container: '#slider_cards',
            nav: false,
            controls: false,
            mouseDrag: true,
            speed: 600,
            autoplayButtonOutput: false,
            slideBy: 1,
            center: true,
            preventScrollOnTouch: 'auto',
            preventActionWhenRunning: true,
            items: 1,
            loop: true,
            edgePadding: 15,
            autoWidth: true,
            center: true,
            responsive: {
                420: {
                    edgePadding: 30,
                },
                540: {
                    edgePadding: 0,
                    items: 2,
                },
                768: {
                    autoWidth: false,
                    edgePadding: 0,
                    items: 3,
                    slideBy: 1
                },
                992: {
                    disable: true
                },
                1440: {
                    items: 4
                },
            }
        }); 
        
        // Slider Global reach
        this._sliderReach = tns({
            container: '#slider_reach',
            nav: false,
            mouseDrag: true,
            controls: false,
            edgePadding: 30,
            speed: 600,
            autoplayButtonOutput: false,
            slideBy: 1,
            preventScrollOnTouch: 'auto',
            preventActionWhenRunning: true,
            items: 1,
            loop: true,
            responsive: {
                992: {
                    edgePadding: 0,
                    items: 2.5,
                    mouseDrag: false,
                },
            }
        });

        // Slider team btn next

        this._sliderRecognitions.events.on('indexChanged', (e) => {
            let pager = document.querySelector('.section_recognitions .slider-pager');
            pager.children[0].innerHTML = ("00" + e.displayIndex).slice(-2);

            let currentMobile = document.querySelector('#slider_recognitions .slider-carousel__item--current');
            if(currentMobile){
                currentMobile.classList.remove('slider-carousel__item--current');
            }
            
            document.querySelectorAll('#slider_recognitions .tns-slide-active')[1].classList.add('slider-carousel__item--current');
        }); 

        Array.from(document.querySelectorAll('#slider_reach_content .dynamic-content__text')).forEach((item, index)=>{
            if(item.classList.contains('dynamic-content__text--active')){
                item.style.display = 'block';
            }else{
                item.style.display = 'none';
            }                
        });
        
        document.getElementById('slider_reach_btn_next').addEventListener('click', (e)=>{
            e.preventDefault();
            this._sliderReach.goTo('next');
        });

        document.addEventListener('click',(e) => {
            if(this._draggableAreaCards._clickEnabled === false){
                return false;
            }
            if(e.target && e.target.classList.contains('modal-link')){
                let target = e.target;
                var source = target.getAttribute('data-source');
                var type = target.getAttribute('data-type');
                //console.log('the type is' + type);
                App.modalVideo.show(source, type);
            } else if(e.target && e.target.parentNode.parentNode.classList.contains('modal-link')){
                let target = e.target.parentNode.parentNode;
                var source = target.getAttribute('data-source');
                var type = target.getAttribute('data-type');
                //console.log('the type is' + type);
                App.modalVideo.show(source, type);
            }
            
        });

        this._sliderReach.events.on('indexChanged', (e) => {
            Array.from(document.querySelectorAll('#slider_reach_content .dynamic-content__text')).forEach((item, index)=>{
                if(index == (e.displayIndex - 1)){
                    item.style.display = 'block';
                    item.classList.add('dynamic-content__text--active');
                }else{
                    item.style.display = 'none';
                    item.classList.remove('dynamic-content__text--active');
                }                
            });
            
        });  

    }

}

export default AboutUs;
